import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = { class: "account-content" }
const _hoisted_3 = {
  key: 0,
  class: "subLabel"
}
const _hoisted_4 = {
  key: 1,
  class: "subLabel"
}
const _hoisted_5 = {
  key: 0,
  class: "loader"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "payment-result"
}
const _hoisted_8 = {
  key: 0,
  class: "debug-info"
}
const _hoisted_9 = {
  key: 1,
  class: "payment-result-container is-error"
}
const _hoisted_10 = { class: "payment-error-headline" }
const _hoisted_11 = { class: "payment-error-text" }
const _hoisted_12 = { class: "payment-error-message" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 2,
  class: "payment-result-container is-success"
}
const _hoisted_15 = { class: "payment-success-headline" }
const _hoisted_16 = { class: "payment-success-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PageHeader, { defaultHeader: true }, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('header.payment')), 1),
          (_ctx.checkStatusInProgress)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('paymentModeChecking')), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('paymentMode')), 1))
        ]),
        _: 1
      }),
      (_ctx.checkStatusInProgress)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createElementVNode("i", {
              class: "svg-icon svg-icon--loader",
              innerHTML: _ctx.icons.loader
            }, null, 8, _hoisted_6)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("p", null, "checkoutId: " + _toDisplayString(_ctx.checkoutId), 1),
                  _createElementVNode("p", null, "resourcePath: " + _toDisplayString(_ctx.resourcePath), 1),
                  _createElementVNode("p", null, "resultCode " + _toDisplayString(_ctx.resultCode), 1),
                  _createElementVNode("p", null, "resultDescription " + _toDisplayString(_ctx.resultDescription), 1),
                  _createElementVNode("p", null, "timestamp " + _toDisplayString(_ctx.timestamp), 1),
                  _createElementVNode("p", null, "paymentSuccessfully " + _toDisplayString(_ctx.paymentSuccessfully), 1),
                  _createElementVNode("p", null, "paymentPending " + _toDisplayString(_ctx.paymentPending), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.paymentSuccessfully)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('paymentFailed')), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('paymentFailedText')), 1),
                  _createElementVNode("p", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.resultCode), 1),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.resultDescription), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentSuccessfully)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t('paymentThankYou')), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('paymentSuccessText')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              text: _ctx.$t('button.backToAccount'),
              onHandleClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleBackToAccount()))
            }, null, 8, ["text"])
          ]))
    ])
  ]))
}